import {formatNumber} from "../../../../common/utils/utils";

export const BiDashboardsUrl = "https://bi-dashboards-2.vidazoo.com/reporting"

export const CUSTOM_DATE_KEYS = ["from", "to"];
export const CUSTOM_COMPARE_DATE_KEYS = ["compareFrom", "compareTo"];

export const defaultFieldFormat = (v: number) => formatNumber(v, 2);
